<template>
    <div class="select-wrapper">
        <slot></slot>
        <svg-pointer class="svg-pointer" :width="20" :height="20"></svg-pointer>
    </div>
</template>

<script>
    import SvgPointer from '@theme-views/common/SvgIcon/Icons/Pointer'

    export default {
        components: {SvgPointer},
    }
</script>

<style lang="scss">
.select-wrapper {
    .svg-pointer {
        z-index: 2;
        position: absolute;
        pointer-events: none;
        right: 0;
        top: 50%;
        transform: translate(-50%, -50%) rotate(-90deg);
        height: 20px;
        width: 20px;
        svg {
            width: 15px;
            height: 15px;
            g.adjust {
                transform: translate(8px, 4px);
            }
        }
    }
}
</style>
